import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NotificationContainerView } from './container_view';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const EmailPreview = ({ messages }) => {
    if (!messages) {
        return null;
    }
    return (_jsx(NotificationContainerView, { children: _jsx("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                backgroundColor: 'rgb(226,225,225)',
                borderRadius: 'calc(1rem - 4px)',
                overflowY: 'auto',
            }, children: _jsx("div", { style: {
                    margin: '1em',
                    background: '#fff',
                    borderRadius: '5px',
                }, children: _jsxs("div", { style: {
                        padding: '2em',
                    }, children: [_jsx("div", { style: {
                                fontSize: '1.4em',
                                fontWeight: 'bold',
                                overflowWrap: 'break-word',
                            }, children: messages.subject || 'subject' }), _jsx("div", { style: {
                                margin: '1em 0',
                                overflowWrap: 'break-word',
                            }, children: _jsx("div", { dangerouslySetInnerHTML: { __html: messages.html || messages.plain } }) })] }) }) }) }));
};
//# sourceMappingURL=email.preview.component.js.map